import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Sensors } from "@usereactify/search";
import { ProntoProvider } from "../providers/pronto"

import { Results } from "./Results/results";

if (
  window.location.pathname.startsWith("/collection")
) {
  const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    mode: "collection",
    shopifyPermanentDomain: "salt-and-pepper-au.myshopify.com",
  });
  const ReactifySearchProvider = ReactifySearchFactory.getProvider();
  const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();
  const ReactifySearchData = ReactifySearchFactory.getData();

  ReactDOM.render(
    <React.StrictMode>
      <ReactifySearchProvider>
        <Sensors />
        <ProntoProvider>
          <Results data={ReactifySearchData} />
        </ProntoProvider>
      </ReactifySearchProvider>
    </React.StrictMode>,
    ReactifySearchMountNode
  );
}
